export default __webpack_public_path__ + "static/media/search.936a04ae.svg";